<template>
  <div class="iam-list-page app-content">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="iam.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>
    
    <div
      v-for="tab in Object.values(tabs)"
      :key="tab.type"
      class="app-content-create"
    >
    
      <!-- Filter button -->
      <app-filter-button
        v-if="activeTabIndex === tab.index"
        :active.sync="activeFilter"
      />

      <router-link
        v-if="tab.buttonLink && activeTabIndex === tab.index"
        :to="{ path: tab.buttonLink }"
      >
        <el-button class="app-content-create-button" type="primary">
          <app-i18n :code="tab.buttonCode" />
        </el-button>
      </router-link>
    </div>

    <!-- Filter form -->
    <app-iam-list-filter v-if="activeFilter && activeTabIndex === tabs.managers.index" />
    <app-coach-list-filter v-if="activeFilter && activeTabIndex === tabs.coaches.index" />

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="iam.title"></app-i18n>
      </h1>

      <app-iam-list-toolbar v-if="activeTabIndex === tabs.managers.index"></app-iam-list-toolbar>
      <!-- <app-iam-list-filter v-if="activeTabIndex === tabs.managers.index"></app-iam-list-filter> -->
      <app-iam-list-table v-if="activeTabIndex === tabs.managers.index"></app-iam-list-table>
      <app-coach-list-table v-if="activeTabIndex === tabs.coaches.index"></app-coach-list-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { i18n } from '@shared/i18n';

import { IamPermissions } from '@modules/iam/iam-permissions';
import IamListFilter from '@modules/iam/components/iam-list-filter.vue';
import IamListTable from '@modules/iam/components/iam-list-table.vue';
import IamListToolbar from '@modules/iam/components/iam-list-toolbar.vue';
import CoachListPage from '@modules/coach/components/coach-list-page.vue';
import CoachListFilter from '@modules/coach/components/coach-list-filter.vue'; 
import CoachListTable from '@modules/coach/components/coach-list-table.vue'; 

export default {
  name: 'app-iam-list-page',

  data() {
    return {
      activeFilter: false,
    };
  },

  computed: {
    ...mapGetters({
      activeTabIndex: 'layout/headerTabs/activeTabIndex',
      currentUser: 'auth/currentUser',
      currentManage: 'auth/manage/currentManage',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      rows: 'iam/list/rows',
    }),
    hasPermissionToCreate() {
      return new IamPermissions(this.currentUser).create;
    },
    isAdmin() {
      return this.currentUser && this.currentUser.isAdmin
    },
    tabs() {
      return {
        managers: {
          isDisabled: false,
          type: 'managers',
          label: i18n('staff.tabs.managers'),
          index: 0,
          routerPush: {
            params: {
              tabName: 'managers'
            }
          },
          buttonLink: '/iam/managers/new',
          buttonCode: 'iam.newManager.title',
        },
        coaches: {
          isDisabled:  process.env.VUE_APP_DISABLE_COACHES_TAB === 'true',
          type: 'coaches',
          label: i18n('staff.tabs.coaches'),
          index: 1,
          routerPush: {
            params: {
              tabName: 'coaches'
            }
          },
          buttonLink: this.isPropertyNBA === false ? '/iam/coach/new' : '',
          buttonCode: this.isPropertyNBA === false ? 'entities.coach.new.title' : '',
        }
      
      }
    }, 
  },

  mounted() {    
    this.coachTabIsDisabled();
    const enabledTabList = Object.values(this.tabs).filter(
      (elem) => {
        return elem.isDisabled == false;
      },
    );

    
    this.setTabs(enabledTabList);    
    this.parseActiveTab();

  },

  beforeDestroy() {
    this.resetTabs();
  },

  methods: {
    ...mapActions({
      setTabs: 'layout/headerTabs/setTabs',
      setActiveTabIndex: 'layout/headerTabs/setActiveTabIndex',
      resetTabs: 'layout/headerTabs/resetTabs',
    }),
    parseActiveTab() {
      const routeTabIndex = this.$route.params.tabName;
      if (routeTabIndex) this.setActiveTabIndex(this.tabs[routeTabIndex].index);
      else this.setActiveTabIndex(Object.values(this.tabs)[0].index);
    },
    coachTabIsDisabled(){
      const isAvailableOnSubproperty  = this.currentManage.type == 'subproperty';
      const isDisabled  = process.env.VUE_APP_DISABLE_COACHES_TAB === 'true';

      this.tabs.coaches.isDisabled = !isAvailableOnSubproperty || isDisabled;
    }
  },

  components: {
    [IamListFilter.name]: IamListFilter,
    [IamListTable.name]: IamListTable,
    [IamListToolbar.name]: IamListToolbar,
    [CoachListPage.name]: CoachListPage,
    [CoachListTable.name]: CoachListTable,
    [CoachListFilter.name]: CoachListFilter,
  },
  
  watch: {
    '$route': 'parseActiveTab'
  },
};
</script>

<style>
</style>
